import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from '../../components/generalForm';
import { connect } from 'react-redux';
import PAYMENT_REFUND_PAYER from '../../components/constants/paymentRefundPayer';
import CustomSelect from '../../components/customFields/customSelect';

const GroupRefundForm = ({ intl, deliveryDayMarketplaceId, closeModal }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refundProperties, setRefundProperties] = useState({
    deliveryDayMarketplaceId,
    payer: PAYMENT_REFUND_PAYER.producer,
  });

  const payerOptions = Object.keys(PAYMENT_REFUND_PAYER).map((key) => {
    const type = PAYMENT_REFUND_PAYER[key];
    return {
      value: type,
      label: intl.formatMessage({ id: 'payment.refund.form.field.payer.' + type }),
    };
  });

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      amount: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.refund.form.field.amount.label' }),
        default: '0',
      },
      itemId: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.refund.form.field.item.id.label' }),
        default: '',
      },
      payer: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.refund.form.field.payer.label' }),
        default: '',
        options: payerOptions,
      },
      comment: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.refund.form.field.comment.label' }),
        default: '',
      },
      deliveryDayMarketplaceId: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.refund.form.field.delivery.day.marketplace.id.label' }),
        default: '',
      },
    },
  };

  const uiSchema = {
    amount: {
      'ui:help': intl.formatMessage({ id: 'payment.refund.form.field.amount.help' }),
    },
    payer: {
      'ui:field': 'customSelect',
    },
  };

  function onFormSubmit() {
    setLoading(true);

    apiCalls
      .createPaymentRefund(refundProperties)
      .then((result) => {
        setLoading(false);
        const successCopy = result.data.email
          ? 'payment.refund.form.create.success.alert.with.email'
          : 'payment.refund.form.create.success.alert.no.email';

        alert(intl.formatMessage({ id: successCopy }));
        closeModal();
      })
      .catch((error) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(error, true));
        window.scrollTo(0, 0);
      });
  }

  const buttonCopy = 'refund.create.form.submit';

  const formFields = {
    customSelect: CustomSelect,
  };

  const header = intl.formatMessage({ id: 'refund.create.header' });

  return (
    <div className="row">
      <div className="col-12 col-lg-10 offset-lg-1 admin__form">
        <GeneralForm
          title={header}
          onChange={(event) => setRefundProperties(event.formData)}
          onSubmit={onFormSubmit}
          formSchema={formSchema}
          formUiSchema={uiSchema}
          formFields={formFields}
          formData={refundProperties}
          buttonCopy={buttonCopy}
          errorMessage={error}
          loading={loading}
          hideImageUpload={true}
        />
      </div>
    </div>
  );
};

GroupRefundForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deliveryDayId: PropTypes.number.isRequired,
};

GroupRefundForm.defaultProps = {};

function mapStateToProps(state) {
  return {};
}

export default injectIntl(connect(mapStateToProps)(GroupRefundForm));
